const PbxxRecord = require('../pbxx_record')

module.exports = class Group extends PbxxRecord {
  static get class_name() {
    return 'Group'
  }
}
